import { METHOD } from './method'

export const API_VOUCHER = {
    COMPARISON: {
        api: '/v1/dashboard-admin/analytic/voucher/comparison',
        method: METHOD.GET,
    },
    GRAPH: {
        api: '/v1/dashboard-admin/analytic/voucher/graph',
        method: METHOD.GET,
    },
    LIST: {
        api: '/v1/dashboard-admin/analytic/voucher/list',
        method: METHOD.GET,
    },
    EXPORT: {
        api: '/v1/dashboard-admin/analytic/voucher/list/export',
        method: METHOD.GET,
    },
}
